import { render } from "./registrationModal.vue?vue&type=template&id=55096013&scoped=true"
import script from "./registrationModal.vue?vue&type=script&lang=js"
export * from "./registrationModal.vue?vue&type=script&lang=js"

import "./registrationModal.vue?vue&type=style&index=0&id=55096013&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55096013"]])

export default __exports__